import { render, staticRenderFns } from "./DisplayOnly.vue?vue&type=template&id=3dfe5757&scoped=true&"
import script from "./DisplayOnly.vue?vue&type=script&lang=js&"
export * from "./DisplayOnly.vue?vue&type=script&lang=js&"
import style0 from "./DisplayOnly.vue?vue&type=style&index=0&id=3dfe5757&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfe5757",
  null
  
)

export default component.exports